<template>
  <div class="body">
    <div class="title">
      数据报表
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/dataReportByApproval' }"
            ><span class="dsadf"> 入园审批 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item>数据报表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left">
        <el-input
          style="width: 320px"
          clearable
          v-model="query.title"
          size="mini"
          placeholder="请输入学校名称搜索"
        >
          <template slot="append">
            <el-button type="primary" @click="Discountsearch">搜索</el-button>
          </template>
        </el-input>
      </div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            时间
            <el-date-picker
              size="mini"
              style="width: 140px"
              v-model="query.s_date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="Discountsearch"
              placeholder="选择开始时间"
            >
            </el-date-picker>
            至
            <el-date-picker
              style="width: 140px"
              size="mini"
              v-model="query.e_date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束时间"
              @change="Discountsearch"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            区县市
            <el-select
              disabled
              style="width: 140px"
              size="mini"
              v-model="query.city"
              placeholder="请选择区县"
            >
              <el-option
                v-for="item in [{ value: '区县市 1' }, { value: '区县市 2' }]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            街道
            <el-select
              disabled
              size="mini"
              style="width: 140px"
              v-model="query.county"
              placeholder="请选择街道"
            >
              <el-option
                v-for="item in [{ value: '街道市 1' }, { value: '街道市 2' }]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" @click="handleAllExport">
              <i class="el-icon-download"></i>
              导出
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <vxe-table
      size="mini"
      :data="reportList"
      border
      stripe
      resizable
      max-height="750"
      class="mytable-scrollbar"
      show-overflow
      keep-source
      align="center"
      :highlight-current-column="true"
    >
      <vxe-table-column field="date" title="日期" min-width="200">
      </vxe-table-column>
      <vxe-table-column field="title" title="学校名称" min-width="100">
      </vxe-table-column>
      <vxe-table-column field="user_num" title="锻炼人数" min-width="100">
      </vxe-table-column>
      <vxe-table-column field="open_num" title="锻炼人次" min-width="100">
      </vxe-table-column>
      <vxe-table-column field="street_name" title="所属地区" min-width="220">
      </vxe-table-column>
    </vxe-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10,15]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getReportList, applyOperate } from "@/api/school";
import dayjs from "dayjs";

export default {
  name: "index",
  data() {
    return {
      dialogVisibleByNotApplroved: false,
      currentSchool: {
        id: "",
        status: "",
        remark: "",
      },
      pageshow: true,
      total: null,
      query: {
        token: sessionStorage.getItem("token"),
        title: "",
        area_code: "",
        street_code: "",
        s_date: "",
        e_date: "",
        page: 1,
        pagesize: 10,
      },
      reportList: [],
      token: sessionStorage.getItem("token"),
      cur_page: 1,
    };
  },
  created() {
    this.getReportList();
  },
  methods: {
    handleAllExport() {
      window.open(
        `https://ydmxhapi.yundongm.cn:8099/service/admin/school/report_export?token=${sessionStorage.getItem(
          "token"
        )}`
      );
    },
    handleChangePass(item) {
      console.log("_handleChangePass", item);
      this.currentSchool = item;

      this.$confirm(
        `确定将「${item.realname}」密码重置为【bxydm@202304】, 是否继续?`,
        "重置密码",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          beforeClose: async (action, instance, done) => {
            if (action === "cancel") return done();
            if (action === "confirm") {
              // TODO：重置密码

              setTimeout(() => {
                this.getReportList();
                done();
              }, 700);
            }
          },
        }
      ).catch(() => {});
    },
    handleApplicationNotApplroved(item) {
      console.log("_审核不通过", item);
      this.currentSchool = item;
      this.$nextTick(() => {
        this.dialogVisibleByNotApplroved = true;
      });
    },
    async handleNotApplroved() {
      console.log("_notapplroved", this.currentSchool);
      const resp = await applyOperate({
        id: this.currentSchool.id,
        status: "3",
        remark: this.currentSchool.remark,
      });
      console.log("_handleNotApplroved", resp);

      this.dialogVisibleByNotApplroved = false;
      setTimeout(() => {
        this.getReportList();
        this.currentSchool = {};
      }, 700);
    },

    Discountsearch() {
      this.cur_page = 1;
      this.getReportList();
      this.pageshow = false; // 让分页隐藏
      this.$nextTick(() => {
        // 重新渲染分页
        this.pageshow = true;
      });
    },
    getReportList() {
      getReportList(this.query).then(({ data: res }) => {
        console.log("res", res);
        this.reportList = res.data.list;
        this.total = res.data.total - 0;
        console.log("_this.getReportList", this.reportList);
      });
    },

    handleSizeChange(val) {
      this.query.pagesize = val;
      this.handleCurrentChange(this.query.page);
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getReportList();
    },
  },
};
</script>

<style scoped lang="less">
.imgs {
  width: 130px;
  height: 70px;
  background: rgba(0, 0, 0, 0);
  border-radius: 2px;
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf {
      color: #3d9aff;
    }
  }
  .btnsearch {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .left {
      margin-right: 150px;
    }
    .right {
      margin-top: 27px;
    }
  }
}
</style>
